import React, {Component} from 'react';
import './SettingsPage.css';
import utils from '../../utils/utils';
import history from '../../history';
export const SettingRow = (props) => {
	return <div className={`row ${props.className || ''}`}>{props.children}</div>;
};

export const invalidEmails = (emailsString = '') => {
	const emails = (emailsString || '').split(',');
	const invalidEmails = [];
	for (let em of emails) {
		if (utils.isValidEmail(em.trim())) continue;
		invalidEmails.push(em);
	}
	return invalidEmails.join(',');
};

export default class SettingsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user_group: {},
			activeCard: 'permission',
			autoLogOutAfterHours: '',
			integrations: [],
		};
	}

	componentDidMount = () => {
		history.navigate('/settings/general');
	};

	render() {
		return null;
	}
}


// WEBPACK FOOTER //
// ./src/pages/settingsPage/SettingsPage.jsx